import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
  selector: '[catTemplate]',
})
export class TemplateDirective {
  @Input() type: string;
  @Input('catTemplate') name: string;

  constructor(public template: TemplateRef<any>) {
  }

  getType(): string {
    return this.name;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/ui-base/directives/template/template.directive.ts